<template>
    <b-dropdown
        no-flip
        v-on:shown="toggleClass = 'open'"
        v-on:hidden="toggleClass='hidden'; filter=''"
        :toggle-class="toggleClass"
        @shown="focusSearchBar"
        menu-class="w-100 rounded shadow"
        variant="white border multi-wrapper p-1"
        class="w-100 multi-container">
        <template slot="button-content" class="p-0 bg-white multi-wrapper">
            <b-btn size="sm" variant="white" class="float-left text-muted" v-if="!values.length">
                Please select value(s)
            </b-btn>
            <b-btn size="sm" class="py-0 px-2 m-1 float-left" v-for="(value, index) in values" :variant="variant" :key="index">
                <template v-if="typeof value === 'object'">
                    <span v-html="value[optionLabelField]"></span>
                </template>
                <template v-else>
                    <span v-html="(labelMapping[value]) ? labelMapping[value] : value"></span>
                </template>
                <span class="h6 align-middle ml-2 text-warning font-weight-bold item-remove" @click="removeValue(value)">
                    &times;
                </span>
            </b-btn>
        </template>
        <b-dropdown-header>
            <b-input-group size="sm">
                <b-form-input :disabled="disabled" type="text" placeholder="Search" ref="searchBar"
                v-model="filter" :class="{ 'border-warning': filter }" />
                <b-input-group-text class="py-0" slot="append" :class="{ 'border-warning': filter }">
                    <i class="icon icon-Search h4 p-0 m-0"
                        :class="{ 'text-warning': filter }" />
                </b-input-group-text>
            </b-input-group>
        </b-dropdown-header>
        <b-dropdown-header v-if="allSelected">
            <span class="text-info h5">All options selected</span>
        </b-dropdown-header>
        <b-dropdown-header v-if="limitReached">
            <span class="text-danger h5">Reached value limit of {{ limit }}</span>
        </b-dropdown-header>
        <b-dropdown-item
            v-for="option in filteredOpts"
            v-if="!optionSelected(option) && !allSelected && !limitReached"
            :key="option[optionValueField]"
            @click="addValue(option)">
          {{ option[optionLabelField] }}
        </b-dropdown-item>
    </b-dropdown>
</template>

<style>
.multi-wrapper {
    cursor: text !important;
    width: 100% !important;
}
.multi-wrapper.dropdown-toggle::after {
   display: none !important;
}
.multi-wrapper.open {
    border-bottom-left-radius: 0px;
    border-bottom-right-radius: 0px;
}
.multi-container .dropdown-menu {
    top: -4px !important;
    border-top: 0px;
    border-bottom-left-radius: 1.5rem !important;
    border-bottom-right-radius: 1.5rem !important;
    min-height: 6rem;
    max-height: calc(100% * 5 + 1.5rem);
    overflow-y: scroll;
}
.multi-container .item-remove:not(:hover) {
    color: inherit !important;
}
</style>

<script>
export default {
    props: {
        /* options in [ { value: label: } ] format */
        options: { required: true, type: [ Array, Object ]},
        values: { required: true, type: Array },
        limit: { required: false, default: 999, type: Number },
        valuesOnly: { required: false, default: true, type: Boolean }, /* values array will be literals not objecy val/label */
        optionValueField: { required: false, default: 'value', type: String },
        optionLabelField: { required: false, default: 'label', type: String },
        optionsKeyIsValue: { required: false, default: true, type: Boolean },
        variant: { required: false, default: 'primary', type: String },
        disabled: { required: false, default: false, type: Boolean }
    },
    data () {
        return {
            toggleClass: 'hidden', /* use to remove bottom radius during open */
            filter: ''
        }
    },
    methods: {
        focusSearchBar () {
            let self = this
            this.$nextTick().then(function() { self.$refs.searchBar.$el.focus() })
        },
        label (val) {
            let lfield = this.optionLabelField
            if (lfield in val) {
                return val[lfield]
            }
            return val
        },
        optionSelected (option) {
           return (this.values.indexOf(option[this.optionValueField]) !== -1)
        },
        removeItem (array, item) {
            let index = array.indexOf(item)
            if (index > -1) {
                array.splice(index, 1)
            }
        },
        addValue (option) {
            if (this.valuesOnly) {
                this.values.push(option[this.optionValueField])
            } else {
                this.values.push(option)
            }
        },
        removeValue (value) {
            this.removeItem(this.values, value)
        }
    },
    computed: {
        allSelected () {
            if (Array.isArray(this.options)) {
                return (this.options.length === this.values.length)
            }
            return (Object.keys(this.options).length === this.values.length)
        },
        limitReached () {
            return (this.values.length === this.limit)
        },
        labelMapping () {
            let options = this.options

            let map = {}
            if (Array.isArray(options)) {
                if (!options.length) {
                    return map /* nothin to do dood */
                }
                if (typeof options[0] !== 'object') {
                    for (let literal of options) {
                        map[literal] = literal
                    }
                    return map
                }

                let vfield = this.optionValueField
                let lfield = this.optionLabelField

                for (let entry of options) {
                    map[entry[vfield]] = entry[lfield]
                }
            } else if (typeof options === 'object') {
                if (this.optionsKeyIsValue) {
                    return options /* already flat mapping of value:label */
                } else {
                    for (let key in options) {
                        map[options[key]] = key
                    }
                }
            }

            return map
        },
        opts () {
            let options = this.options

            let vfield = this.optionValueField
            let lfield = this.optionLabelField

            if (Array.isArray(options)) {
                if (!options.length) {
                    return []
                }

                let first = options[0]
                if (typeof first === 'object') {
                    if (this.vfield && this.lfield) {
                        if (!(vfield in first) || !(lfield in first)) {
                            console.error('Key or Label values supplied dont exist in supplied options!')
                            return []
                        }
                    } else {
                        /* options is array of objects, the props key/label values exist - nothing to do */
                        return this.options
                    }
                }

                /* flat array, transform into key,label object format */
                let opts = []
                for (let literal of options) {
                    let item = {}
                    item[vfield] = literal
                    item[lfield] = literal
                    opts.push(item)
                }

                return opts
            }

            if (typeof options === 'object') {
                /* options just an object, map the k:v pairs
                to our array of { value: .., label: .. } objects */
                let opts = []
                for (let key in options) {
                    let kIsVal = this.optionsKeyIsValue
                    let value = options[key]

                    let item = {}
                    if (kIsVal) {
                        item[vfield] = key
                        item[lfield] = value
                    } else {
                        item[vfield] = value
                        item[lfield] = key
                    }

                    opts.push(item)
                }

                return opts
            }

        },
        filteredOpts () {
            let filter = this.filter

            if (!filter || filter === '') {
                return this.opts
            }
            filter = filter.toLowerCase()

            return this.opts.filter((opt) => {
                let val = opt[this.optionValueField].toLowerCase()
                let label = opt[this.optionLabelField].toLowerCase()

                return (val.indexOf(filter) !== -1 ||
                    label.indexOf(filter) !== -1)
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Mulselect.vue